import { ChangeDetectionStrategy, Component, input, output, computed } from '@angular/core';
import { Incident, IncidentStatus, Severity } from '../../models/incident';
import { IncidentComponent } from '../incident/incident';

@Component({
    selector: 'app-timeline',
    imports: [IncidentComponent],
    templateUrl: './timeline.html',
    styleUrl: './timeline.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimelineComponent {
    incidents = input<Incident[]>([]);
    notify = output<Incident>();

    filteredIncidents = computed(() =>
        this.incidents().filter(
            (incident) =>
                incident.status !== IncidentStatus.OnGoing && incident.severity !== Severity.P3,
        ),
    );

    onIncidentNotify(incident: Incident): void {
        this.notify.emit(incident);
    }
}
